<template>
  <section class="m-5">
    <div class="m-5">
      <SkeletonView width="250" height="40" />
    </div>
    <div class="m-5 has-background-white">
      <div class="is-flex align-content-start is-half-width">
        <div class="p-3" v-for="index in 2" :key="index">
          <SkeletonView width="150" height="30" />
        </div>
      </div>
      <hr />
      <div class="is-flex">
        <div class="is-flex align-content-start">
          <div class="p-3 m-t-10">
            <SkeletonView width="250" height="30" />
          </div>
        </div>
        <div class="is-flex align-content-start is-half-width">
          <div class="p-3" v-for="index in 2" :key="index">
            <SkeletonView width="200" height="40" />
          </div>
        </div>
        <div class="is-flex justify-content-end">
          <div class="p-3">
            <SkeletonView width="150" height="40" />
          </div>
        </div>
      </div>
      <div class="p-3">
        <div class="has-border-radius has-border-light">
          <SkeletonView class="is-full-width" height="50" />
          <div class="my-5">
            <div
              v-for="index in 5"
              :key="index"
              class="is-flex is-justify-content-space-evenly my-5"
            >
              <div>
                <SkeletonView height="20" width="100" />
                <SkeletonView height="10" width="200" />
              </div>
              <div>
                <SkeletonView height="40" width="40" circle />
              </div>
              <div class="is-flex is-justify-content-space-evenly">
                <div class="p-1" v-for="index in 2" :key="index">
                  <SkeletonView height="40" width="40" circle />
                </div>
              </div>
              <div>
                <SkeletonView height="20" width="100" />
              </div>
              <div>
                <SkeletonView height="20" width="150" />
              </div>
              <div class="is-flex is-justify-content-space-evenly">
                <div class="p-1" v-for="index in 3" :key="index">
                  <SkeletonView height="30" width="50" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'EstateManageOverviewSkeleton',
  components: { SkeletonView }
};
</script>
